/** Max modifier options shown inline on PDP before "View more" opens the overflow modal. */
export const PDP_MODIFIER_INLINE_OPTION_LIMIT = 8
